import { PrimaryButton } from '../buttons/PrimaryButton';
import { Option, PlanType } from '@raysee/schema';
import Link from 'next/link';
import { FC } from 'react';

interface Props {
  options: Option[];
}

export const OptionsList = ({ options }: Props) => (
  <section className="mt-8 rounded bg-[#F2F2F2] p-2">
    <ul className="mb-0 flex flex-wrap">
      {options.map((option) => (
        <li key={option.id} className="m-2 w-96 rounded-sm border-2 bg-white">
          <Link href={`/options/${option.id}/edit`}>
            <div className="p-2">
              <p className="text-gray-500">
                <OptionScope {...option} />
              </p>
              <p className="text-sm text-black">{option.title}</p>
              <p className="text-gray-500">
                <OptionPlanType {...option} />
              </p>
              <div className="flex flex-row items-center justify-between">
                <p className="text-gray-500">
                  <Price price={option.price} />円
                </p>
                {option.status === 'sale' && <OptionShareLink {...option} />}
                {option.status === 'pause' && (
                  <p className="text-red-500">
                    <OptionStatus {...option} />中
                  </p>
                )}
              </div>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  </section>
);

const OptionStatus: FC<Option> = ({ status }) => {
  switch (status) {
    case 'sale':
      return <>販売</>;
    case 'pause':
      return <>販売停止</>;
  }
};

const OptionScope: FC<Option> = ({ scope }) => {
  switch (scope) {
    case 'public':
      return <>公開</>;
    case 'private':
      return <>非公開</>;
  }
};

const OptionPlanType: FC<Option> = ({ planType, planIds }) => {
  return (
    <div className="flex gap-1">
      {planType.includes(PlanType.Phone) && (
        <div className="bg-brand rounded-[10px] px-2 py-0.5 text-xs font-bold leading-relaxed text-white">
          電話プラン
        </div>
      )}
      {planType.includes(PlanType.Chat) && (
        <div className="bg-brand rounded-[10px] px-2 py-0.5 text-xs font-bold leading-relaxed text-white">
          チャットプラン: {planIds.length} 件
        </div>
      )}
    </div>
  );
};

const OptionShareLink: FC<Option> = ({ id, tellerId }) => (
  <PrimaryButton
    title="リンク発行"
    onClick={() =>
      navigator.clipboard
        .writeText(`https://raysee.jp/tellers/${tellerId}/options/${id}?utm_medium=tellerselfpr`)
        .then(() => window.alert('リンクをコピーしました！'))
    }
  />
);

const Price: FC<{ price: number }> = ({ price }) => (
  <>{new Intl.NumberFormat('ja-JP').format(price)}</>
);
